import React, { useState, useEffect, Suspense } from 'react';
import DraftEditor from './common/DraftEditor';
import { ADDITIONAL_SECTIONS_LINK, FINALIZE_LINK, FINAL_RESUME, NEXT_LABEL, POPUP_TYPES, SUMMARY_LINK, SUMMARY_TIPS_LINK } from '../constants/constants';
import { Redirect } from 'react-router';
import { useResume } from '../context/ResumeContext';
import GPTSuggestionPopup from './common/GPTSuggestionPopup';
import { useDispatch, ReactReduxContext } from 'react-redux';
import { updateProfilePictureStatus, uploadProfileImage } from '../services/actions/actions';
import Loader from './common/Loader';
import { usePopup } from '../context/PopupContext';
import QuickTips from './common/QuickTips';
import { setBodyHeight } from '../helper';
import UploadIcon from '../assets/images-new/icons/upload.svg';
const PhrasesPopup = React.lazy(() => import("./common/PhrasesPopup"));
const EditorSummary = (props) => {
    const {
      resume: {
        heading: { fname, profession, show_profile_picture, lname, profile_picture }, //Used to intentify component is ignored with first call with initial-data, and react with second time component is called with user input data            summary,
        enabled_tabs,
        skipped_sections,
        summary,
        active_template
      },
      handlers: {
        updateResumePreview,
        nuteralizeNextClick,
        nuteralizeBackClick,
      },
      next_clicked,
      back_clicked,
      skip_clicked,
      toggleSkip,
      toggleProfilePicture,
      has_profile_picture
    } = useResume();

    const errorStyle = { color: 'red', fontSize: '10px' }
    const [error, setError] = useState({})
    //Flag is Do Next redirect
    const [redirectNext, setredirectNext] = useState(false)
    //Flag is Do Back redirect
    const [redirectBack, setredirectBack] = useState(false)
    //Component asked to redirect, first validate
    const [callOnce, setcallOnce] = useState(false)
    const [skipSection, setSkipSection] = useState(false)
    const [showAIPopup, setShowAIPopup] = useState(false);
    const [showPhrasePopUp, setShowPhrasePopUp] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const [showNameInput, setShowNameInput] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [imageName, setImageName] = useState(profile_picture ? profile_picture : '');
    const [blabel, setblabel] = useState('Upload');
    const skipped = skipped_sections?.includes('summary')
    const dispatch = useDispatch();
    const confirmbox = usePopup();
    const type = 'summary';
    //Quick edit mode
    const QEM = enabled_tabs.includes('completed')
    const label = (l) => QEM ? NEXT_LABEL : l
    const rURL = (u) => QEM ? FINAL_RESUME : u

    const nextClicked = () => {
        let skipped = skipped_sections?.includes('summary')
        if (skip_clicked) {
            return toggleSkip('summary')
        } else if (next_clicked) {//Set for next page
            const blk = checkBlankSection()
            if (blk && !skipped) {
                confirmbox.show('section_skip', null, () => {
                    toggleSkip('summary');
                    setredirectNext(true)
                })
                nuteralizeNextClick({ next_label: 'Not completed' },true, QEM ? '' : 'completed');
                return false
            }else{
            nuteralizeNextClick({ next_label: NEXT_LABEL, skip_label: skipped ? 'Add' : 'Skip' }, true, QEM ? '' : 'completed')
            return true
            }
        } else {//Set for own page
            //Always run for next click and self label not matched
            nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped ? 'Add' : 'Skip' })
            return false
            // }
        }
    }
    const processing = (s) => s ? setblabel('Processing...') : setblabel('Upload')
    const updateImage = (f) => {
    processing(true);
    if (f[0] !== undefined) {
      const uploadedImage = f[0];
      if (uploadedImage.size > 2097152) {
        setErrorMsg('The image exceeds the maximum allowed size (2MB). Please try a smaller image.');
        // setTimeout(() => {
        //   setErrorMsg('');
        // }, 5000);
        processing(false);
        return false;
      } else {
        (dispatch(uploadProfileImage(f[0])).then(res => {
          if (res.msg == 'success') {
            processing(false);
            setImageName(res.name);
          }
        }).catch(error => {
          console.log('got en error', error);
          setErrorMsg(error);
          setTimeout(() => {
            setErrorMsg('');
          }, 5000);
          processing(false);
        }))
      }
    }
  }

    const backClicked = () => {
        if (back_clicked) {
            nuteralizeBackClick({ next_label: label(NEXT_LABEL) })
            return true
        }
    }

    const emptyAiData = () => {
        const aidata = (localStorage.getItem('aidata') ? JSON.parse(localStorage.getItem('aidata')) : {});
        if (aidata.heading) {
            delete aidata.heading;
            //localStorage.removeItem('aidata');
            localStorage.setItem('aidata', JSON.stringify(aidata));
        }
    }

    const getShortName = (fname, lname) => {
      const a = fname ? fname.charAt(0) : '';
      const b = lname ? lname.charAt(0) : '';
      return a + b;
    };

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: '' })
    }
    useEffect(() => {
      dispatch(updateProfilePictureStatus(active_template));
    }, []);
    useEffect(() => {
        setSkipSection(skipped_sections?.includes('summary'))
    }, [skipSection, skipped_sections]);
    useEffect(() => {
      confirmbox.configurePopup(POPUP_TYPES);
    }, []);

    useEffect(() => {
        if (nextClicked()) setredirectNext(true)
        else setredirectNext(false)
        if (backClicked()) setredirectBack(true)
        else setredirectBack(false)

        setcallOnce(false)
    }, [callOnce, fname]);
    // nextClicked()

    const checkBlankSection = () =>  (summary.content.trim().length == 0 || summary.content.trim() == '<p><br></p>')
    const showTabOpenCloseIcon = () => (
        props.hasOwnProperty('tabOpened') ?
          <span className="open-close-btn pink" onClick={() => {
            props.tabClicked('summary', false);
            setBodyHeight();
          }}>
            {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
            </span> : ''
      )
    //Keep the control on multiple rendering and out of limit. Force to update once
    if ((next_clicked || back_clicked) && !callOnce) setcallOnce(true);



    // if (!active_tabs.includes('summary')) return <Redirect to={HEADING_LINK} />
    if (redirectNext) { history.pushState(null, SUMMARY_LINK); return <Redirect to={FINAL_RESUME} /> }
    if (redirectBack) return <Redirect to={rURL(SUMMARY_TIPS_LINK)} />

    return (<>
        <div className="editor-block-inner">
            <div className="editor-area pink-line">
                <div className="form-heading">
                    <div className={`on-off-btn ${skipSection ? 'disabled' : 'pink'}`} onClick={e => skipped ? toggleSkip('summary') : confirmbox.show('section_skip', null, () => toggleSkip('summary'))}>
                        <span><i></i></span>
                    </div>
                    <div className="heading" onClick={() => props.hasOwnProperty('tabOpened') && props.tabClicked('summary')}>
                        <h1>Create Your Summary</h1>
                        <p>Provide a brief overview of your experience, education, skills, and career goals.</p>
                    </div>
                    {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips pink">
            <span
              onClick={() => {
                setShowToolTip(!showToolTip);
              }}><i className="icon-lightbulb-on"></i>Quick Tips</span>
            {showToolTip ? <QuickTips section="summary" setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
          </div>}
          {showTabOpenCloseIcon()}
                </div>
                
                {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="editor-form">
                    <div className="form-row editor-summary">
                    {has_profile_picture && 
                    <div className="field-wrap">
              <label className="label editor-label profile-label">Profile Picture</label>
              <div className="profile-wrap">
                <div className="profile-preview">
                  {show_profile_picture ? (
                    profile_picture && Object.keys(profile_picture).length ? (
                        <span className="image-placeholder">
                        <img src={profile_picture.picture_path} alt="" width="39" />
                        </span>
                    ) : (
                        <span className="image-placeholder">
                        {fname ? getShortName(fname, lname) : "CC"}
                        </span>
                    )
                    ) : (
                    <span className="image-placeholder">
                        <i className="icon-eye-slash"></i>
                    </span>
                    )}
                  
                </div>
                <div className="upload-field">
                  <div 
                    className={`on-off-btn-s${!show_profile_picture ? ' disabled' : '' }`} 
                    onClick={ () => {
                      return (!show_profile_picture
                        ? toggleProfilePicture()
                        : confirmbox.show('show_profile_picture', null, () => toggleProfilePicture()));
                    }
                  }>
                  <span><i></i></span><em className="show-pic-label">Show Picture</em></div>
                  <label htmlFor="profile_image" className="upload-label">{blabel} <i className="upload-icon"><UploadIcon /></i></label>
                  <input
                    style={{ visibility: 'hidden', width: '150px' }}
                    type="file"
                    className="form-input"
                    name="profile_picture"
                    id="profile_image"
                    value=''
                    onChange={(e) => {
                      //Remove Error if already set
                      setErrorMsg('');
                      //Remove image if already uploaded
                      /*heading.hasOwnProperty('profile_picture') && Object.keys(heading.profile_picture).length ? update({ profile_picture: {} }) : '';*/
                      //Upload Image
                      updateImage(e.target.files);
                    }}
                  />
                </div>
              </div>
                </div>
                }
                {ErrorMsg.length ? <span style={errorStyle} className="pic-valid">{ErrorMsg}</span> : ''}
                        <div className="field-wrap editor-field">
                            {/* <label htmlFor="description" className="label">Summary</label> */}
                            <DraftEditor
                                name="description"
                                placeholder="e.g. Dedicated [High School] Teacher with [7] years of experience…"
                                className="validate"
                                textAlignment='left'
                                value={summary.content}
                                onInputChange={(val) => {
                                    updateResumePreview({ summary: { content: val }, current_tab: 'summary' });
                                }}
                                chatGptButton={true}
                                phrasesButton={true}
                                colorType="dark-blue"
                                showAIPopup={showAIPopup}
                                setShowAIPopup={(showAIPopup) => { setShowAIPopup(showAIPopup) }}
                                showPhrasePopUp={showPhrasePopUp}
                                setShowPhrasePopUp={(showPhrasePopUp) => { setShowPhrasePopUp(showPhrasePopUp) }}
                            />

                            {error.content && (
                                <span style={errorStyle}>{error.content}</span>
                            )}
                            {showAIPopup
                                && <GPTSuggestionPopup
                                    section="heading"
                                    phrase={profession}
                                    id="summary"
                                    data={summary}
                                    updateAction={updateResumePreview}
                                    setShowAIPopup={(a) => setShowAIPopup(a)}
                                />
                                }

                            {showPhrasePopUp
                                ? <Suspense fallback={<Loader />}>
                                    <PhrasesPopup
                                        section='heading'
                                        phrase={profession}
                                        id={props.id}
                                        updateAction={updateResumePreview}
                                        setShowPhrasePopUp={(s) => setShowPhrasePopUp(s)}
                                    />
                                </Suspense>
                                : ''}
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    </>);
}

export default EditorSummary;

